export default __webpack_public_path__ + "static/media/2031.ed3a7c03.png";